<div *ngIf='sessionData' class='UserContactsGroup'>
  <div class='UserContactsGroup-header d-flex flex-column flex-sm-row'>
    <div
      class='UserContactsGroup-header-title flex-grow-1 d-flex flex-row align-items-center'>
      <div class='flex-grow-1'>
        <h4 class='title__page'>Contacts</h4>
        <app-svg-renderer
          (click)='onInfoImageClick()'
          [svg]="'Yellow Plane'"></app-svg-renderer>
      </div>
    </div>
    <div class='UserContactsGroup-header-info flex-grow-0 flex-row d-none d-sm-flex'>
      <div class='UserContactsGroup-header-info-item flex-grow-1'>
        <p>
          Today:
          <span
            (click)="
              showLastContacts('contacts_today', lastContacts.contacts_today)
            "
            *ngIf='lastContacts && lastContacts.contacts_today >= 0'
          >{{ lastContacts.contacts_today }}</span
          >
          <mat-spinner
            *ngIf='!lastContacts'
            color='primary'
            diameter='20'
            mode='indeterminate'>
          </mat-spinner>
        </p>
      </div>
      <div class='UserContactsGroup-header-info-item flex-grow-1'>
        <p>
          This week:
          <span
            (click)="
              showLastContacts(
                'contacts_lastweek',
                lastContacts.contacts_lastweek
              )
            "
            *ngIf='lastContacts && lastContacts.contacts_lastweek >= 0'
          >{{ lastContacts.contacts_lastweek }}</span
          >
          <mat-spinner
            *ngIf='!lastContacts'
            color='primary'
            diameter='20'
            mode='indeterminate'>
          </mat-spinner>
        </p>
      </div>
      <div class='UserContactsGroup-header-info-item flex-grow-1'>
        <p>
          This month:
          <span
            (click)="
              showLastContacts(
                'contacts_thismonth',
                lastContacts.contacts_thismonth
              )
            "
            *ngIf='lastContacts && lastContacts.contacts_thismonth >= 0'
          >{{ lastContacts.contacts_thismonth }}</span
          >
          <mat-spinner
            *ngIf='!lastContacts'
            color='primary'
            diameter='20'
            mode='indeterminate'>
          </mat-spinner>
        </p>
      </div>
      <div class='UserContactsGroup-header-info-item flex-grow-1'>
        <p>
          Last Month:
          <span
            (click)="
              showLastContacts(
                'contacts_lastmonth',
                lastContacts.contacts_lastmonth
              )
            "
            *ngIf='lastContacts && lastContacts.contacts_lastmonth >= 0'
          >{{ lastContacts.contacts_lastmonth }}</span
          >
          <mat-spinner
            *ngIf='!lastContacts'
            color='primary'
            diameter='20'
            mode='indeterminate'>
          </mat-spinner>
        </p>
      </div>
    </div>
    <div class='d-block d-sm-none'>
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title><b>Status</b></mat-panel-title>
          </mat-expansion-panel-header>
          <p>
            <b>Today: </b>
            <span
              (click)="
              showLastContacts('contacts_today', lastContacts.contacts_today)
            "
              *ngIf='lastContacts && lastContacts.contacts_today >= 0'
            >{{ lastContacts.contacts_today }}</span
            >
            <mat-spinner
              *ngIf='!lastContacts'
              color='primary'
              diameter='20'
              mode='indeterminate'>
            </mat-spinner>
          </p>
          <p>
            <b>This week: </b>
            <span
              (click)="
              showLastContacts(
                'contacts_lastweek',
                lastContacts.contacts_lastweek
              )
            "
              *ngIf='lastContacts && lastContacts.contacts_lastweek >= 0'
            >{{ lastContacts.contacts_lastweek }}</span
            >
            <mat-spinner
              *ngIf='!lastContacts'
              color='primary'
              diameter='20'
              mode='indeterminate'>
            </mat-spinner>
          </p>
          <p>
            <b>This month: </b>
            <span
              (click)="
              showLastContacts(
                'contacts_thismonth',
                lastContacts.contacts_thismonth
              )
            "
              *ngIf='lastContacts && lastContacts.contacts_thismonth >= 0'
            >{{ lastContacts.contacts_thismonth }}</span
            >
            <mat-spinner
              *ngIf='!lastContacts'
              color='primary'
              diameter='20'
              mode='indeterminate'>
            </mat-spinner>
          </p>
          <p>
            <b>Last Month: </b>
            <span
              (click)="
              showLastContacts(
                'contacts_lastmonth',
                lastContacts.contacts_lastmonth
              )
            "
              *ngIf='lastContacts && lastContacts.contacts_lastmonth >= 0'
            >{{ lastContacts.contacts_lastmonth }}</span
            >
            <mat-spinner
              *ngIf='!lastContacts'
              color='primary'
              diameter='20'
              mode='indeterminate'>
            </mat-spinner>
          </p>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
  <div class='UserContactsGroup-table'>
    <div class='d-flex flex-row py-3'>
      <app-button
        *ngIf='showOneTimeMessage && !oneTimeMessageWithContacts'
        [Click]='oneTimeMessageButtonProperties.onClick'
        [color]='oneTimeMessageButtonProperties.color'
        [size]='oneTimeMessageButtonProperties.size'
        [style]='oneTimeMessageButtonProperties.style'
        [text]='oneTimeMessageButtonProperties.text'></app-button>
    </div>
    <div class='my-3'>
      <mat-radio-group
        (change)='changeTableFilters($event, $event?.value)'
        [value]='selectedTableFilter' aria-label='Select an user type'>
        <mat-radio-button
          class='me-2'
          value='keyword'
        >Keyword
        </mat-radio-button
        >
        <mat-radio-button
          *ngIf='tagsFilterAvailble'
          class='me-2'
          value='tags'
        >Tags
        </mat-radio-button
        >
      </mat-radio-group>
    </div>
    <app-table
      #tableComponent
      (rowSelected)='onRowsSelection($event)'
      *ngIf='tableReady'
      [columns]='tableColumns'
      [dataSourceParams]='tableDataSourceParams'
      [dataSource]='dataSource'
      [filterGroups]='tableFiltersGroups'
      [rowClass]='getRowClass'
      [rowHover]='getRowHover'
      [selectable]='
        sessionData?.one_time_message && !oneTimeMessageWithContacts
      '
      [useRouteNavigation]='false'>
      <ng-template [appTableMobileRow] let-currentUser='currentUser' let-row='row'>
        <app-user-groups-listing-mobile-row (manage)='openManageDialog($event)'
                                            (send)='openSendToCampaignDialog($event)'
                                            *ngIf='!oneTimeMessageWithContacts'
                                            [item]='row'></app-user-groups-listing-mobile-row>
        <app-contacts-listing-mobile-row (activity)='openActivityDialog($event)' (vip)='toggleContactVip($event)'
                                         *ngIf='oneTimeMessageWithContacts'
                                         [item]='row'></app-contacts-listing-mobile-row>
      </ng-template>
    </app-table>
  </div>
</div>
